import { ApiReferenceReact } from '@scalar/api-reference-react'
import { Link } from 'react-router-dom'

export default function Reference() {
  return (
    <div className="reference-shell">
      <div className="reference-topbar">
        <Link to="/" className="reference-topbar-back">
          ← Chosen API docs
        </Link>
        <span className="reference-topbar-note">
          Try it now uses your real API key against your real data.
        </span>
      </div>
      <ApiReferenceReact
        configuration={{
          url: '/openapi.public.json',
          theme: 'default',
          metaData: {
            title: 'Chosen API Reference',
            description:
              'Programmatic access to Chosen. Authenticate with a `cho_*` Bearer token.',
          },
          authentication: {
            preferredSecurityScheme: 'ApiKeyAuth',
          },
          hideClientButton: false,
          hideDownloadButton: false,
          showSidebar: true,
          servers: [
            {
              url: 'https://hire.chosenhq.com',
              description: 'Production',
            },
            {
              url: 'https://dev.chosenhq.com',
              description: 'Development (Chosen-internal)',
            },
          ],
        }}
      />
    </div>
  )
}
